import { initializeApp, getApps } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: "goodrecord-59fb2.firebaseapp.com",
  projectId: "goodrecord-59fb2",
  storageBucket: "goodrecord-59fb2.firebasestorage.app",
  messagingSenderId: "147660599674",
  appId: "1:147660599674:web:0768465b4c9fd7b6f666c3"
};

const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];
export const db = getFirestore(app);
